import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
    value: null,
    options: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
    value?: string | number;
    options: { label: string; value: string | number, disabled?: boolean }[];
};





function handleInput(e: Event) {
    emit('input', (e.target as HTMLInputElement).value)
}

watch(() => props.value, (newVal) => {
    emit('input', newVal)
})

return { __sfc: true,props, emit, handleInput }
}

})